var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", [
    _c("br"),
    _vm._v(" "),
    _c("span", { staticClass: "modal-body-text" }, [
      _vm._v(
        "You are submitting " +
          _vm._s(_vm.itemName == "all event" ? "" : "event ") +
          " "
      ),
      _c("span", { staticClass: "modal-event-name" }, [
        _vm._v(_vm._s(_vm.itemName == "all event" ? "all event" : _vm.itemName))
      ]),
      _vm._v(" for approval.")
    ]),
    _c("br"),
    _c("br"),
    _vm._v(" "),
    !_vm.showCustomMessage
      ? _c("div", [
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "By submitting this event to ADURO you are agreeing all of the information is accurate\n    and if approved, ADURO will schedule the event."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "If the event is not approved, ADURO will send the event with changes or suggestions\n    back to you."
            )
          ])
        ])
      : _c("div", {
          staticClass: "custom-message modal-body-text",
          domProps: { innerHTML: _vm._s(_vm.customMessage) }
        }),
    _vm._v(" "),
    _c("br"),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ee170212", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee170212","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/SubmitEventModal.vue
// module id = 1375
// module chunks = 1